<template>
    <div class="tx-history-wrap">
        <div v-if="actions && actions.length" class="verifier-chapter-container">
            <div v-for="action in actions" class="verifier-chapter-btn"
                v-bind:class="{'verifier-chapter-btn__active': action.key === currentId }"
                v-on:click="currentId = action.key"
                v-bind:key="`multisig-action-btn-${action.key}`"
            >
                {{ $t('multisig.action') }} #{{action.key}}
            </div>
        </div>
        <template v-if="actions && actions.length">
            <!--<div class="card-row">-->
            <!--    <div class="card-row__name">-->
            <!--        Action ID-->
            <!--    </div>-->
            <!--    <div class="card-row__value">-->
            <!--        {{ selectedAction.key }}-->
            <!--    </div>-->
            <!--</div>-->

            <div class="card-row">
                <div class="card-row__name">
                    {{ $t('multisig.action_type') }}
                </div>
                <div class="card-row__value">
                    {{ $t(`multisig.${selectedAction.type}`) }}
                </div>
            </div>

            <!-- send_message actions -->
            <div class="card-row" v-if="selectedAction?.destination">
                <div class="card-row__name">
                    {{ $t('address.tx_table.to') }}
                </div>
                <div class="card-row__value">
                    <ui-address v-bind:address="selectedAction.destination" />
                </div>
            </div>

            <div class="card-row" v-if="selectedAction?.amount">
                <div class="card-row__name">
                    {{ $t('address.tx_table.value') }}
                </div>
                <div class="card-row__value">
                    <span v-if="selectedAction.amount === 'all'">
                        {{ $t('multisig.all_balance') }}
                    </span>
                    <span v-else>
                        {{ $ton(selectedAction.amount) }} TON
                    </span>
                </div>
            </div>

            <div class="card-row" v-if="selectedAction?.body">
                <div class="card-row__name">
                    Body
                </div>
                <div class="card-row__value">
                    {{ selectedAction.body }}
                </div>
            </div>

            <div class="card-row" v-if="selectedAction?.sendMode">
                <div class="card-row__name">
                    Send mode
                </div>
                <div class="card-row__value">
                    {{ selectedAction.sendMode }}
                </div>
            </div>

            <!-- update_multisig_params actions -->
            <div class="card-row" v-if="selectedAction?.newThreshold">
                <div class="card-row__name">
                    New threshold
                </div>
                <div class="card-row__value">
                    {{ selectedAction.newThreshold }}
                </div>
            </div>

            <div class="card-row" v-if="selectedAction?.newSigners">
                <div class="card-row__name">
                    New signers
                </div>
                <div class="card-row__value">
                    <p
                        v-for="signer of selectedAction.newSigners"
                        v-bind:key="`multisig-signer-${signer}`"
                    >
                        <ui-address v-bind:address="signer" />
                    </p>
                </div>
            </div>

            <div class="card-row" v-if="selectedAction?.newProposers">
                <div class="card-row__name">
                    New proposers
                </div>
                <div class="card-row__value">
                    <p
                        v-for="proposer of selectedAction.newProposers"
                        v-bind:key="`multisig-proposer-${proposer}`"
                    >
                        <ui-address v-bind:address="proposer" />
                    </p>
                </div>
            </div>
        </template>

        <template v-else>
            <div class="tx-history-empty-panel">
                {{ $t('multisig.addresslist_empty') }}
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        actions: Array,
    },

    data() {
        return {
            currentId: 0,
        };
    },

    computed: {
        selectedAction() {
            return this.actions[this.currentId];
        },
    },
};
</script>

<style lang="scss">

</style>
